import { memo, useEffect, useState, useRef } from "react"
import ProductList from "@/components/product/list"
import ProductService from "@/services/product"
import { Box, Flex, Stack, Text, VStack } from "@chakra-ui/react"
import { useNavigate, useParams } from "react-router";
import { HStack, Input, Center, AspectRatio, Button, Image, Table, Container, Wrap, Float, Drawer, CloseButton, Switch, SkeletonText, Separator } from "@chakra-ui/react"
import { LuSearch, LuShoppingCart, LuMessageCircle } from "react-icons/lu"
import { Heading } from "@chakra-ui/react"

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Field } from "@/components/ui/field"
import Slider from "react-slick";
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import SingleProductPrice from "@/components/product/price/SingleProductPrice"
import TierProductPrice from "@/components/product/price/TierProductPrice"
import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"

import _, { set } from "lodash"
import { useStore } from "contexts/store";
import { useAuth } from "contexts/auth"
const ShowLogin = () => {
    const { focusSearch, setFocusSearch, productSearchList, processing, setProcessing, openAddToCart, setOpenAddToCart, addToCartProductID, addToCartVariantID, showToast, showProductSearch, setShowProductSearch } = useApp();
    const { user, showLogin } = useAuth();
    const btnLoginClick = async () => {
        setOpenAddToCart(false);
        showLogin();
    }

    return (
        <div>
            <Drawer.Root open={openAddToCart} onOpenChange={(e) => setOpenAddToCart(e.open)} placement="bottom" closeOnEscape={false} closeOnInteractOutside={false} unmountOnExit={true} >
                <Drawer.Backdrop />
                <Drawer.Positioner >
                    <Drawer.Content>


                        <Container maxW={"md"} maxHeight={"100vh"} overflow={"scroll"} style={{ padding: 0 }}>
                            <Drawer.Header>
                                <div style={{ display: "flex", gap: 4 }}>
                                    <div style={{ flexGrow: 1, flexShrink: 1, justifyContent: "center" }}>

                                        <Drawer.Title>Thêm vào giỏ hàng</Drawer.Title>


                                    </div>
                                    <div>
                                        <Drawer.CloseTrigger asChild>
                                            <CloseButton size="lg" />
                                        </Drawer.CloseTrigger>
                                    </div>

                                </div>


                            </Drawer.Header>
                            <Drawer.Body >

                                <Container maxW={"md"} style={{ padding: 0 }} >



                                    <VStack>
                                        <Text color={"red.500"} fontWeight="semibold">Bạn cần đăng nhập để tiếp tục mua hàng</Text>
                                        <Button onClick={btnLoginClick}>Đăng nhập </Button>

                                    </VStack>












                                </Container>

                            </Drawer.Body>
                            {/* <DrawerFooter>
                            <DrawerActionTrigger asChild>
                                <Button variant="outline">Huỷ</Button>
                            </DrawerActionTrigger>
                            <Button onClick={addToCartClick}>Thêm</Button>
                        </DrawerFooter>
                        <DrawerCloseTrigger /> */}
                            <Drawer.CloseTrigger />

                        </Container>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Drawer.Root>


        </div >
    )
}

export default memo(ShowLogin)